import webpartRegister from "./WebpartRegistration";

/**
 * YASKAWA
 */
import CalendarWebpart from "./YASKAWA/Calendar/CalendarWebpart.vue";
import BoardArticleWebpart from "./YASKAWA/Board/BoardArticleWebpart.vue";
import BoardNoticeWebpart from "./YASKAWA/Board/BoardNoticeWebpart.vue";
import PowerBIWebpart from "./YASKAWA/PowerBi/PowerBIWebpart.vue";
import BudgetComponent from "./YASKAWA/Budget/BudgetComponent.vue";
import ShortcutWebpart from "./YASKAWA/Shortcut/ShortcutWebpart.vue";
import DxWebpart from './YASKAWA/DX/DxWebpart.vue'
import WorkflowCountWebpart from './YASKAWA/Workflow/WorkflowCountWebpart.vue'
import TaskProcessWebpart from './YASKAWA/Task/TaskProcessWebpart.vue'
import DeptCalendarWebpart from './YASKAWA/Calendar/DeptCalendarWebpart.vue'
import MyPeople from "./NewStone/MyPeples/MyPeoplesWebpart.vue";
import MyTeams from "./NewStone/MyTeams/MyTeamsWebpart.vue";
import MyRecentFiles from "./NewStone/RecentFiles/RecentFilesWebpart.vue";


webpartRegister.register("articleboard-webpart", BoardArticleWebpart, "board", "게시글목록 표시 웹파트", "게시판");
webpartRegister.register("calendar-event", CalendarWebpart, "calendar", "달력,일정 표시 웹파트", "일정");
webpartRegister.register("noticeboard-webpart", BoardNoticeWebpart, "board", "공지사항목록 표시 웹파트", "공지사항");
webpartRegister.register("my-people", MyPeople, "mypeople", "관련 인물 리스트", "관련 인물");
webpartRegister.register("my-teams", MyTeams, "myteams", "나의 팀즈", "나의 팀즈");
webpartRegister.register("my-recent-files", MyRecentFiles, "myRecentFiles", "나의 최근 파일", "나의 최근 파일");
/**
 * YASKAWA
 */
webpartRegister.register("powerbi-webpart", PowerBIWebpart, "powerbi", "PowerBI 웹파트", "PowerBI");
webpartRegister.register("budget-webpart", BudgetComponent, "budget", "예산관리 웹파트", "예산관리");
webpartRegister.register("quickmenu-webpart", ShortcutWebpart, "quickmenu", "퀵메뉴 웹파트", "퀵메뉴");
webpartRegister.register('dx-webpart', DxWebpart, "dx", "DX 웹파트", "Digital Transformation");
webpartRegister.register('wf-count-webpart', WorkflowCountWebpart, 'workflow-count', '전자결재 카운팅 웹파트', "기안/결재 문서함");
webpartRegister.register('task-webpart', TaskProcessWebpart, 'task', '업무프로세스 웹파트', '업무 프로세스');
webpartRegister.register('dept-calendar', DeptCalendarWebpart, 'dept-calendar', '부서원 일정 표시 웹파트', "부서일정");

